export const GET_BUV = '/get_buv';
export const GET_SINGLE_BUV = '/get_single_buv';
export const UPDATE_BUV = '/update_buv';
export const CREATE_BUV = '/create_buv';
export const REMOVE_BUV = '/remove_buv';
export const GET_LAND_CLASSIFICATIONS = 'buv/get_land_classification_list';
export const GET_SUB_CLASSICATION_LIST = 'buv/get_sub_classification_list';
export const GET_LOCATION_LIST = 'buv/get_location_list';
export const GET_ORDINANCE_REVISION = 'buv/get_ordinance_revision_list';
export const GET_DISTRICT_LIST = 'buv/get_district_list';
export const GET_STREETS = '/get_street';

export const FORM_DATA = {
  street_code: '',
  street_from: '',
  street_to: '',
  land_classification_id: '',
  land_sub_classification_id: '',
  ordinance_revision_id: '',
  rptax_location_id: '',
  rptax_district_id: '',
};